import DocumentFooter from './DocumentFooter';

export default DocumentFooter;
